import { TweenMax } from "gsap";
import App from "../../../vendor_core/core/src/App";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import WinSymbolsView from "../../../vendor_core/core/src/views/WinSymbolsView";
import BBModel from "../model/BBModel";
import BBAnimationsHelper from '../utils/BBAnimationsHelper';
import BBReelGroup from "../view/BBReelGroup";


export default class ShowWinState extends State {
    summaryComplete: boolean;
    bannerComplete: boolean;
    private displayWinDelay: number = 0.3;
    protected reelGroup: BBReelGroup;
    public winSymbolsView: WinSymbolsView

    public enter(): void {
        // console.log(BBModel.cascades[SpinModel.cascadeIndex]?.transform?.length, "showlength")
        // console.log(SpinModel.cascadeIndex, "showindex")
        if ((BBModel.cascades[0]?.transform?.length > 0 && SpinModel.cascadeIndex == 0 ||
            BBModel.cascades[SpinModel.cascadeIndex]?.transform?.length > BBModel.cascades[SpinModel.cascadeIndex - 1]?.transform?.length
            && !SpinModel.isInFreespins())) {
            let layer = ViewManager.getLayer(DefaultLayers.Paylines).getCurrentScene()
            TweenMax.delayedCall(0.6, () => {
                if (layer.getSubView("wildEffect")) {
                    layer.removeSubView("wildEffect")
                }
            })
            TweenMax.delayedCall(0.7, () => {
                SpinModel.currentWin += SpinModel.getCurrentSpinProperty("winAmount");
                // CommandManager.execute(Commands.UPDATE_WIN);
                super.enter();
                this.summaryComplete = false;
                this.bannerComplete = false;
                const scene = ViewManager.getLayer(
                    DefaultLayers.Reels
                ).getCurrentScene();
                this.reelGroup = scene.getSubView("ReelGroup") as BBReelGroup;
                if (SpinModel.isInFreespins() && !GameModel.gameConfig.totalWinFromServer) {
                    SpinModel.updateFreespinWinnings();
                } else {
                    // UIController.setState(UIStates.IDLE);
                }
                this.attachOnCompleteEvent();
                this.displayWin();
            })
        } else {
            SpinModel.currentWin += SpinModel.getCurrentSpinProperty("winAmount");
            // CommandManager.execute(Commands.UPDATE_WIN);
            super.enter();
            this.summaryComplete = false;
            this.bannerComplete = false;
            const scene = ViewManager.getLayer(
                DefaultLayers.Reels
            ).getCurrentScene();
            this.reelGroup = scene.getSubView("ReelGroup") as BBReelGroup;
            if (SpinModel.isInFreespins() && !GameModel.gameConfig.totalWinFromServer) {
                SpinModel.updateFreespinWinnings();
            } else {
                // UIController.setState(UIStates.IDLE);
            }
            this.attachOnCompleteEvent();
            this.displayWin();
        }

    }

    public canExit(): boolean {
        /**
         * Override method to alow externel skip of state
         */
        return App.config.canSkipWin;
    }

    displayWin() {
        // CommandManager.execute(Commands.UPDATE_WIN);
        // if (!SpinModel.isInFreespins()) {
        //     CommandManager.execute(Commands.UPDATE_BALANCE);
        // }
        // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").disableMask();

        TweenMax.delayedCall(this.displayWinDelay, () => {
            this.reelGroup.displaySummaryResult(SpinModel.getCurrentWinsData());
            BBAnimationsHelper.playBeatLogoAnim();
        })

        // if (SpinModel.getCurrentWin() > 0 && SpinModel.getCurrentWinsData().find(win => win.creditsWon > 0)) {
        //     // this.reelGroup.winlinesView.setWinBannerValue(
        //     //     SpinModel.getCurrentWin(),
        //     //     App.config.bangupWin
        //     // );
        // } else {
        //     this.bannerComplete = true;
        // }
    }

    protected internalExit() {
        this.reelGroup.scaleOffWilds();
        // BBAnimationsHelper.unBlackingSymbols(this.reelGroup);
        TweenMax.delayedCall(0.8, () => {
            // debugger
            this.exit();
        });
    }

    public exit(): void {
        if (this.reelGroup.winlinesView.winValueBanner) {
            this.reelGroup.winlinesView.winValueBanner.visible = false;
        }
        super.exit();
        if (!SpinModel.isInFreespins()) {
            CommandManager.execute(Commands.UPDATE_WIN);
            CommandManager.execute(Commands.UPDATE_BALANCE);
        }
        const layer1 = ViewManager.getLayer(DefaultLayers.Paylines);
        const scene1 = layer1.getCurrentScene();
        if (scene1.getSubView("banner") != undefined) {
            scene1.removeSubView("banner")
        }
        if (scene1.getSubView("multi") != undefined) {
            scene1.removeSubView("multi")
        }
        if (scene1.getSubView("megaBanner") != undefined) {
            scene1.removeSubView("megaBanner")
        }
        if (scene1.getSubView("megaMulti") != undefined) {
            scene1.removeSubView("megaMulti")
        }
        // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").enableMask();
        // TweenMax.killAll()

        // let wilds = this.reelGroup.searchWilds()
        // if(wilds.length > 0){
        //     wilds.forEach(wild => {
        //         // debugger
        //         let symParent = this.reelGroup.winSymbolsView.getAnimAtReelCell(wild.x, wild.y).parent
        //         symParent.removeChildAt(this.reelGroup.wildSymbolAnim);
        //     });
        // }
        this.removeOnCompleteEvent();
    }

    protected onWinComplete() {
        // debugger
        this.summaryComplete = true;
        if (this.summaryComplete && this.bannerComplete) {
            this.internalExit();
        }
    }

    protected onBannerComplete() {
        this.bannerComplete = true;
        if (this.summaryComplete && this.bannerComplete) {
            this.internalExit();
        }
    }

    protected attachOnCompleteEvent() {
        // App.dispatcher.once(GameEvents.SHOW_WIN_LINES_COMPLETE, this.exit, this);
        // if (GameModel.gameConfig.waysGame) {
        this.reelGroup.once(
            GameEvents.WIN_ANIMATIONS_COMPLETE,
            this.onWinComplete,
            this
        );
        this.bannerComplete = !App.config.bangupWin;

        if (App.config.bangupWin) {
            this.reelGroup.winlinesView.once(
                GameEvents.BANNER_ANIM_COMPLETE,
                this.onBannerComplete,
                this
            );
        }
        // }
    }

    protected removeOnCompleteEvent() {
        this.reelGroup.off(
            GameEvents.WIN_ANIMATIONS_COMPLETE,
            this.onWinComplete,
            this
        );

        if (App.config.bangupWin) {
            this.reelGroup.winlinesView.off(
                GameEvents.BANNER_ANIM_COMPLETE,
                this.onBannerComplete,
                this
            );
        }
    }
}
